import React from 'react';
import PropTypes from 'prop-types';

import YearbookRosterIdentity from './YearbookRosterIdentity';
import withModal from '../modal/withModal';

export const YEARBOOK_ROSTER_IDENTITY_MODAL = 'MODAL/YEARBOOK_ROSTER_IDENTITY';

const propTypes = {
  actionProps: PropTypes.shape({
    albumFolderId: PropTypes.string,
    rosterIdentityId: PropTypes.string,
  }),
};

const YearbookRosterIdentityModal = ({ actionProps, ...props }) => {
  const { albumId, albumFolderId, rosterIdentityId, identity } =
    actionProps ?? {};

  return (
    <YearbookRosterIdentity
      albumId={albumId}
      albumFolderId={albumFolderId}
      rosterIdentityId={rosterIdentityId}
      identity={identity}
      {...props}
    />
  );
};

YearbookRosterIdentityModal.propTypes = propTypes;

export default withModal(YearbookRosterIdentityModal, {
  name: YEARBOOK_ROSTER_IDENTITY_MODAL,
  size: 'md',
  type: 'full',
});
